import { render, staticRenderFns } from "./makeUpExamSignUp.vue?vue&type=template&id=bf99edf4&scoped=true"
import script from "./makeUpExamSignUp.vue?vue&type=script&lang=js"
export * from "./makeUpExamSignUp.vue?vue&type=script&lang=js"
import style0 from "./makeUpExamSignUp.vue?vue&type=style&index=0&id=bf99edf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf99edf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf99edf4')) {
      api.createRecord('bf99edf4', component.options)
    } else {
      api.reload('bf99edf4', component.options)
    }
    module.hot.accept("./makeUpExamSignUp.vue?vue&type=template&id=bf99edf4&scoped=true", function () {
      api.rerender('bf99edf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/makeUpExamSignUp.vue"
export default component.exports